import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import IgniteDataTable from '../common/datatable'
import {dateFormat} from '../../utils/commonFunctions';

class IndividualRewardsStatementList extends Component {
  constructor(props){
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  render() {
    const columns = [
      {prop: 'created-at', title: 'Date', width: '100', format(data, row) {return dateFormat(data)}},
      {prop: 'store', title: 'Store', width: '100'},
      {prop: 'user', title: 'User', width: '100'},
      {prop: 'description', title: 'Description', width: '270'},
      {prop: 'value', title: 'Value', width: '100', format(data, row) {return <b>{data}</b>}},
      {prop: 'balance', title: 'Balance', width: '100', format(data, row) {return <b>{data}</b>}},
    ];

    const columnsMobile = [
      {prop: 'transaction', title: 'Transaction', format(data, row) {
          const balanceClass = +row.attributes['balance'] > 0 ? 'm-transaction-balance positive' : 'm-transaction-balance negative';

          return (
            <Grid bsClass="container" fluid>
              <Row>
                <Col xs={12}>
                  <div className="m-transaction-date">{dateFormat(row.attributes['created-at'])}</div>
                </Col>
              </Row>
              <Row>
                <Col xs={8}>
                  {row.attributes['description']}
                </Col>
                <Col xs={4} className="ta-right">
                  <div>{row.attributes['value']}</div>
                  <div className={balanceClass}>{row.attributes['balance']}</div>
                </Col>
              </Row>
            </Grid>
          )
        }},
    ];

    return (
      this.props.points_statement &&
      <Row>
        <Col smHidden xsHidden>
          <IgniteDataTable data={this.props.points_statement}
                           dataSize={this.props.pagination.number * this.props.pagination.size}
                           columns={columns}
                           pagination={{
                             onPageChange: this.props.onPageChange,
                             page:         this.props.currentPage
                           }}
                           remote/>
        </Col>

        <Col lgHidden mdHidden className="m-transactions">
          <IgniteDataTable data={this.props.points_statement}
                           dataSize={this.props.pagination.number * this.props.pagination.size}
                           columns={columnsMobile}
                           pagination={{
                             onPageChange: this.props.onPageChange,
                             page:         this.props.currentPage
                           }}
                           remote/>
        </Col>
      </Row>
    )
  }
}

export default connect()(IndividualRewardsStatementList)



// WEBPACK FOOTER //
// ./src/components/points-statement/individual-rewards-statement-list.jsx